import React, { FC } from 'react';
import { TNavigationBarMSRPDesktop } from '../types/navigationBar.types';
import { Text } from '@sitecore-jss/sitecore-jss-react';

const NavigationBarMSRPDesktop: FC<TNavigationBarMSRPDesktop> = (props) => {
  const { optionalLabel1, optionalLabel2, msrp } = props;

  return (
    <div className={'navigation-bar-container__price-container'}>
      <Text className="navigation-bar-container__price-optional-label" tag="p" field={{ value: optionalLabel2 }} editable={false} />
      <span className="navigation-bar-container__price">
        <Text tag="p" field={{ value: optionalLabel1 }} className="navigation-bar-container__price-label" />
        &nbsp;
        <Text tag="p" field={{ value: msrp }} editable={false} />
      </span>
    </div>
  );
};

export default NavigationBarMSRPDesktop;
